import React from "react";
import { ArrowUpRight, ExternalLink } from "lucide-react";
import ImageFrame from "@/components/ImageFrame";

const ctaForUrl = (url = "") => {
  if (!url) return "See the post";
  if (url.includes("youtu")) return "Watch the episode";
  if (url.includes("x.com") || url.includes("twitter.com")) return "Read the thread";
  if (url.includes("etmoney.com")) return "Visit page";
  if (url.includes("instagram.com")) return "See the post";
  return "Check it out";
};

export const WorkCard = ({ index, tag, title, caption, link, image, ratio = "1/1" }) => {
  const cta = ctaForUrl(link);

  const body = (
    <div className="group block">
      <div className="overflow-hidden border border-[#EDE4D3]/8">
        <ImageFrame filename={image} ratio={ratio} />
      </div>
      <div className="mt-5 flex items-start justify-between gap-6">
        <div>
          <p className="text-[11px] uppercase tracking-[0.24em] text-[#D4A574]">
            {tag || index}
          </p>
          <h3 className="mt-2 font-serif text-xl leading-snug text-[#EDE4D3]">
            {title}
          </h3>
          {caption && (
            <p className="mt-3 text-[13px] leading-relaxed text-[#EDE4D3]/60">
              {caption}
            </p>
          )}
          {link && (
            <span
              className="mt-5 inline-flex items-center gap-2 font-serif text-[15px] italic text-[#EDE4D3] transition-colors group-hover:text-[#D4A574]"
              data-testid={`cta-${index}`}
            >
              {cta}
              <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
              <ExternalLink className="h-3.5 w-3.5 opacity-70" />
            </span>
          )}
        </div>
        {link && (
          <ArrowUpRight className="mt-1 h-4 w-4 shrink-0 text-[#EDE4D3]/35 transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#D4A574]" />
        )}
      </div>
    </div>
  );

  if (link) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        data-testid={`work-card-${index}`}
        className="block"
      >
        {body}
      </a>
    );
  }
  return <div data-testid={`work-card-${index}`}>{body}</div>;
};

export default WorkCard;
